<script>
  import { layoutMethods, prpMethods } from "@/state/helpers";
  import { required } from "vuelidate/lib/validators";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * PRP Category List component
   */
  export default {
    page: {
      title: "PRP Category Form"
    },
    components: {
    },
    computed: {
    },
    data() {
      return {
        title: "PRP Category Form",
        prp_category_id : 0,
        form:{
          status          : true,
          name            : null
        },
        formExitChecker:{
          status          : true,
          name            : null
        },
        submitted : false,
        prpCategoryModule: {
          access: {
            create: true,
            read: true,
            update: true,
            delete: true
          }
        }
      };
    },
    validations: {
      form: {
        status              : {required},
        name                : {required}
      },
    },
    methods: {
      ...layoutMethods,
      ...prpMethods,
      cancelRouting(){
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "PRP Category"
            }
          );
      },
      async handleSubmit(){
        this.submitted = true
        this.$v.$touch();
        if (!this.$v.form.$invalid){
            console.log(":: FORM ::", JSON.stringify(this.form));
            await this.actionPRP({
                action: (this.prp_category_id > 0 ? "update":"create")+"-category",
                body: this.prp_category_id > 0 ? {...this.form,"prp_category_id":this.prp_category_id}:this.form
            })
            .then((res) => {
              console.log(res);
              Swal.fire(
                (this.prp_category_id > 0 ?"Updated":"Created")+" Successful!",
                `${this.form.name} has been ${(this.prp_category_id > 0 ?"updated":"created")}.`,
                "success"
              );
              this.formExitChecker = {...this.form}
              this.cancelRouting();
            }).catch((e)=>{
              console.log("error while creating a job",e);
              Swal.fire(
                (this.prp_category_id > 0 ?"Update":"Create")+" Failed!",
                e,
                "warning"
              );
            });
        }
      },
      async getCategoryDetails(){
        await this.actionPRP({
            action: "category-details",
            body: {"prp_category_id":this.prp_category_id}
        })
        .then((res) => {
          this.form.status                = res["message"]["status"] 
          this.form.name                  = res["message"]["name"]
          this.formExitChecker            = {...this.form}
        }).catch((e)=>{
          console.log("error while getting details",e);
        });
      },
      leaveform(next){
          if(JSON.stringify(this.form) == JSON.stringify(this.formExitChecker)){
            next();
            return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{
                  return;
              }
          })
      },
    },
    async mounted(){
      this.changeTitle({title: 'PRP Category Form'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'PRP Category', to: { name: 'PRP Category'} },
          { text: 'PRP Category Form', to: { name: 'PRP Category Form'} }
        ]
      });
      this.prp_category_id = this.$route.params.id;
      if(this.prp_category_id > 0){
        // alert("hey eedited");
        this.getCategoryDetails();
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'PRP', 'PRP Category')
        .then((access) => this.prpCategoryModule.access = access);
    },
    beforeRouteLeave(to, from, next) {
        if(JSON.stringify(this.form) != JSON.stringify(this.formExitChecker)){
          this.leaveform(next);
        }else{
          next();
        }
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-6 offset-md-3">
            <div class="card">
                <div class="card-body">
                  
                  <form class="px-4" @submit.prevent="handleSubmit()">
                    <div class="row">
                      <label v-if="prp_category_id <= 0 && !prpCategoryModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a PRP Category.</label>
                      <label v-else-if="prp_category_id > 0 && !prpCategoryModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a PRP Category.</label>    
                      <div class="col-md-12 mb-3"><!--start active status-->
                        <div class="form-check form-switch">
                          <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                          <input
                            class="form-check-input"
                            v-model="form.status"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                          />
                        </div>
                      </div><!--end active status-->
                      <div class="mb-3 col-md-12"><!--Category Name-->
                        <label class="form-label small fw-bold">Category Name<span style="color: red">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.name"
                          placeholder="Enter PRP Category Name"
                          :class="{
                              'is-invalid': submitted && $v.form.name.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.name.$error"
                          class="text-danger">
                          <span v-if="!$v.form.name.required">This value is required.</span>
                        </div>
                      </div><!--Category Name-->

                    </div><!--end of row-->

                    <div class="row mt-3 mb-2 px-3"><!--start of row button group-->
                      <div class="col-md-12 mt-3 ta-right p-0">
                        <b-button :disabled="prp_category_id <= 0 ? !prpCategoryModule.access.create : !prpCategoryModule.access.update" variant="primary" class="w-sm me-2" type="submit">{{this.prp_category_id  == 0 ? "Save" : "Update"}}</b-button>
                        <b-button variant="light" class="w-sm ml-2" type="button" @click="cancelRouting" >Cancel</b-button>
                      </div>
                    </div><!--end of row button group-->

                    </form>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>